<nb-card>
  <nb-card-body class="hierarchy-setup">
    <div
      class="d-flex align-items-center mt-4 {{ hierarchy?.class || '' }}"
      *ngFor="let hierarchy of hierarchies"
    >
      <div
        class="d-flex flex-row align-items-center"
        *ngFor="let data of hierarchy?.hierarchy; let i = index"
      >
        <div
          class="px-3 py-2 hierarchy-box"
          style="min-width: 10rem"
          [style.background]="data?.backgroundColor || '#f4f4f4'"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <nb-icon
                style="width: 1.5rem !important; height: 1.5rem"
                [icon]="data?.icon"
                pack="fci"
              ></nb-icon>
              <span class="ml-2 weight-600">{{ data?.label }}</span>
            </div>
          </div>
          <div class="mt-3" *ngIf="data?.metadata">
            <div
              class="d-flex align-items-center justify-content-between mt-2"
              *ngFor="let prop of data?.metadata | keyvalue"
            >
              <span class="label">{{ prop?.key }}</span>
              <app-smart-table-long-string-ellipsis
                [value]="
                  jsonStringify({
                    value: prop?.value || 'N/A',
                    truncateLength: 15
                  })
                "
              ></app-smart-table-long-string-ellipsis>
            </div>
          </div>
          <div
            *ngIf="data?.containerButton || data?.showFooterBtn"
            class="mt-3 d-flex"
          >
            <app-rbac-button
              *ngIf="data?.containerButton"
              [label]="data?.containerButton?.label"
              [status]="data?.containerButton?.status || 'primary'"
              [appearance]="data?.containerButton?.appearance || 'outline'"
              [size]="data?.containerButton?.status || 'small'"
              [action]="data?.containerButton?.action"
              [inputClusterId]="data?.value"
              (onClick)="addImageEvent($event, data)"
            ></app-rbac-button>
            <app-rbac-button
              *ngIf="data?.showFooterBtn"
              [label]="data?.footerBtnLabel"
              [ngClass]="{ 'ml-3': data?.containerButton }"
              status="primary"
              appearance="outline"
              size="small"
              (onClick)="onTitleClick(data)"
            ></app-rbac-button>
          </div>
        </div>
        <div *ngIf="data?.showConnection" class="text-center">
          <app-rbac-button
            *ngIf="
              data?.showConnectionBtn && i !== hierarchy?.hierarchy?.length - 1
            "
            [label]="data?.connectionBtn?.label"
            class="ml-1"
            [status]="data?.connectionBtn?.status || 'primary'"
            [appearance]="data?.connectionBtn?.appearance || 'outline'"
            [size]="data?.connectionBtn?.status || 'small'"
            [action]="data?.connectionBtn?.action"
            [inputClusterId]="data?.value"
            (onClick)="
              emitPromoteEvent($event, data, hierarchy?.hierarchy[i + 1])
            "
          ></app-rbac-button>
          <div>
            <nb-icon
              *ngIf="i !== hierarchy?.hierarchy?.length - 1"
              class="ml-2 mr-2 mt-2 arrow-icon"
              style="color: #1fb75a; width: 100px !important"
              icon="arrow-long"
              pack="fci"
            ></nb-icon>
          </div>
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
